const WHITESPACE_ENTRY_FROM_PATH_KEY = 'ppa_whitespace_entry_from_path';
const PACK_ARCH_ENTRY_FROM_PATH_KEY = 'ppa_pack_arch_entry_from_path';

const normalizeAppPath = (pathname: string) => pathname.replace(/^\/+/, '') || 'direct';

const setStoredPath = (key: string, value: string) => {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        // Ignore quota / private-mode failures; entry_point will fall back to 'direct'.
    }
};

const getStoredPath = (key: string) => {
    try {
        return sessionStorage.getItem(key) || 'direct';
    } catch {
        return 'direct';
    }
};

export const rememberMixpanelEntryFromPath = (pathname: string) => {
    if (!pathname) return;
    const normalized = normalizeAppPath(pathname);
    if (!pathname.includes('whitespace-analysis')) {
        setStoredPath(WHITESPACE_ENTRY_FROM_PATH_KEY, normalized);
    }
    if (!pathname.includes('pack-architecture')) {
        setStoredPath(PACK_ARCH_ENTRY_FROM_PATH_KEY, normalized);
    }
};

export const getWhitespaceEntryPoint = () => getStoredPath(WHITESPACE_ENTRY_FROM_PATH_KEY);
export const getPackArchitectureEntryPoint = () => getStoredPath(PACK_ARCH_ENTRY_FROM_PATH_KEY);
